export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4831.d9d53e91.jpg";